// eslint-disable-next-line
import React, { useCallback, useEffect, useState } from "react";
import UploadProduct from "../components/uplaodProduct/uploadProduct";
import summaryApi from "../common/Api";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { MdOutlineDelete } from "react-icons/md";
import { FiEdit2 } from "react-icons/fi";
import EditProduct from "../components/editProduct/editProduct";
import Loading from "../components/loading/loading";
import ConfirmationModal from "../components/confirmMessage/confirmMessage";
import { GoSearch } from "react-icons/go";
import { useQuery } from "@tanstack/react-query";

const AllProducts = () => {
  const [popup, setPopup] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const [addProduct, setAddProduct] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleConfirm = async () => {
    if (!selectedProductId) return;

    const tokenApi = Cookies.get("tokenApi");
    if (!tokenApi) {
      toast.error("Authentication token is missing. Please log in again.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    try {
      await axios.delete(summaryApi.deleteProduct(selectedProductId).url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
        withCredentials: true,
        fetchProducts: true,
      });
      fetchProducts();
      toast.success("Product deleted successfully!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      const productsData = await fetchProducts();
      // setProducts(productsData);
      return productsData;
    } catch (error) {
      console.error("Failed to delete product:", error);
      toast.error("Failed to delete the product.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } finally {
      setSelectedProductId(null);
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    setSelectedProductId(null);
    setIsModalOpen(false);
  };

  const handleClosePopup = () => {
    setPopup(false);
    setAddProduct(false);
    setEditProductId(null);
  };

  const fetchProducts = useCallback(async () => {
    // setLoading(true);
    try {
       const response =await axios.get(summaryApi.getAllProducts.url, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      // setProducts(response?.data?.data);
      return response?.data?.data || [];
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      // setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const {
    data: products = [],
    isLoading,
  } = useQuery({
    queryKey: ["users"],
    queryFn: fetchProducts,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 2,
    keepPreviousData: true,
  });

  const filteredProducts = products?.filter((product) =>
    product?.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 p-5">
        <h2
          style={{ fontFamily: "serif" }}
          className="font-semibold text-xl uppercase"
        >
          All Products:
        </h2>

        <div className="hidden md:flex items-center w-[400px] relative  ">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="Search by product category name..."
            className="border-2 border-gray-300 shadow-sm rounded-full p-2 px-4 w-full outline-none h-[35px] transition-all hover:shadow-md"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="bg-main-background w-10 h-[35px] rounded-r-full absolute right-0 flex items-center justify-center">
            <span className="text-white">
              <GoSearch />
            </span>
          </div>
        </div>
        <div className="flex items-center relative">
          <button
            className="bg-main-background py-2 px-2 rounded-md text-white"
            onClick={() => {
              setAddProduct(true);
              setPopup(true);
            }}
          >
            Upload Product
          </button>
        </div>

        <div className="absolute top-24 flex flex-wrap gap-2 justify-center md:w-[95%] py-2 overflow-auto  overflow-x-hidden max-h-[calc(100vh-250px)] sm:max-h-[300px] md:max-h-[400px] lg:max-h-[calc(100vh-500px)] xl:max-h-[100vh]">
          {filteredProducts?.map((product) => (
            <div
              key={product._id}
              className="bg-white p-4 rounded-lg shadow-md w-full max-w-[250px] overflow-y-scroll"
            >
              <div className="flex items-center relative justify-center m-auto w-48 h-48 ">
                <img
                  src={product.product_image[0]}
                  alt={product.name}
                  loading="lazy"
                  effect="blur"
                  className="w-full h-full object-contain mb-2 cursor-zoom-in"
                />
                <span
                  className="-top-2 -left-6 text-red-600  cursor-pointer rounded-full p-2 hover:bg-red-400 hover:text-white transition-colors absolute "
                  onClick={() => {
                    setSelectedProductId(product._id);
                    setIsModalOpen(true);
                  }}
                >
                  <MdOutlineDelete />
                </span>

                <span
                  className="absolute -top-2 -right-6 text-blue-600  p-2 cursor-pointer rounded-full hover:bg-blue-400 hover:text-white transition-colors"
                  onClick={() => {
                    setPopup(true);
                    setEditProductId(product._id);
                  }}
                >
                  <FiEdit2 style={{ width: 16, height: 16 }} />
                </span>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-ellipsis line-clamp-1 mb-2">
                  {product.name}
                </h3>
              </div>

              <div className="flex justify-between items-center mb-1">
                <p className="text-gray-600 font-semibold">Price: </p>
                <span>${product.price}</span>
              </div>

              <div className="flex justify-between items-center">
                <p className="text-gray-600 font-semibold">Quantity: </p>
                <span>{product.quantity}</span>
              </div>
            </div>
          ))}
        </div>

        {popup && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-500">
            <div className="h-[calc(100vh-144px)] bg-white p-4 rounded-lg shadow-lg w-full max-w-[700px] overflow-y-scroll scroll-smooth">
              {addProduct ? (
                <UploadProduct
                  onClose={handleClosePopup}
                  fetchProducts={fetchProducts}
                />
              ) : (
                editProductId && (
                  <EditProduct
                    onClose={handleClosePopup}
                    fetchProducts={fetchProducts}
                    productId={editProductId}
                  />
                )
              )}
            </div>
          </div>
        )}

        {isModalOpen && (
          <ConfirmationModal
            isOpen={isModalOpen}
            message="Are you sure you want to delete this product?"
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            fetchProducts={fetchProducts}

          />
        )}
      </div>

      {products.length === 0 && (
        <div className="text-center text-lg font-bold mt-10">
          <p className="text-gray-600 mt-4">
            No products available. Please add some products.
          </p>
        </div>
      )}

      {filteredProducts.length === 0 && (
        <div className="text-center text-lg font-bold mt-10">
          <p className="text-gray-600 mt-4">No products found.</p>
        </div>
      )}
    </>
  );
};

export default AllProducts;
